import { render, staticRenderFns } from "./max_amount.vue?vue&type=template&id=c4df13ac&"
import script from "./max_amount.vue?vue&type=script&lang=js&"
export * from "./max_amount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports